module.exports = __webpack_public_path__ + "img/fingerprint.6062ceaf.svg";